export const DATE_FORMAT_DDMMYYYY_SLASH = "DD/MM/YYYY";
export const DATE_FORMAT_MMDDYYYY_SLASH = "MM/DD/YYYY";
export const DATE_FORMAT_MMDDYYYY_hh_mm_A = "MM/DD/YYYY hh:mm A";
export const DATE_FORMAT_YYYYMMDD_HYPHEN = "YYYY-MM-DD";
export const DATE_FORMAT_YYYYMMDD_SLASH = "YYYY/MM/DD";

export default DATE_FORMAT_DDMMYYYY_SLASH;
